import styled from 'styled-components';
import { Form as BaseForm } from 'formik';

import _Raw from 'shared/components/presentational/Raw/Raw';
import BaseWrapper from 'shared/components/presentational/Wrapper/Wrapper';

export const Wrapper = styled(BaseWrapper)`
  --title-position: left;
  padding: 0 var(--spacing-m);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
`;

export const Raw = styled(_Raw)`
  p {
    margin-bottom: 0;
  }
`;

export const Form = styled(BaseForm)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xl);
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
`;
